<h2 mat-dialog-title>{{ 'Crear Archivo/Directorio' }}</h2>

<mat-dialog-content>
  <div class="seleccion">
    <button mat-raised-button color="primary" (click)="onCrearArchivo()">
      {{ 'Archivo' }}
    </button>
    <button mat-raised-button color="primary" (click)="onCrearDirectorio()">
      {{ 'Directorio' }}
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div >
    <button mat-raised-button color="primary" (click)="onCancel()">
      {{ 'Cancel' }}
    </button>
  </div>
</mat-dialog-actions>